<template>
    <div class="d-flex justify-start flex-wrap">
        <selectable-molecule
        class="ma-1"
            v-for="selectableMolecule in this.selectableMolecules"
            v-bind:key="selectableMolecule.molecule.inchi.concat(selectableMolecule.selected ? 1 : 0)"
            v-bind:selectableMolecule="selectableMolecule"
            v-on:unselect-molecule="unselect"
            v-on:select-molecule="select"
        ></selectable-molecule>

    </div>
</template>

<script>
import selectableMolecule from './SelectableMolecule.vue';

export default {
    name: 'SelectableMolecules',
    components: {
        selectableMolecule
    },
    props: {
        selectedMolecules: Array
    },
    data:
        function() {
            return {
                selectableMolecules: []
            }
        },
    methods: {
        initSelectableMolecules(selectedMolecules) {
            return selectedMolecules.map(function(molecule) {
                return {selected: true, molecule: JSON.parse(JSON.stringify(molecule))}
            })
        },
        unselect (unselectedMolecule) {
            var index = this.selectableMolecules.findIndex(selectableMolecule => selectableMolecule.molecule.inchi===unselectedMolecule.inchi)
            if(index!=-1) {
                var updatedMolecule = this.selectableMolecules.find(selectableMolecule => selectableMolecule.molecule.inchi===unselectedMolecule.inchi);
                updatedMolecule.selected = false;
                this.$emit('get-molecules', this.filterSelectedMolecules(this.selectableMolecules))
            }
        },
        select (selectedMolecule) {
            var index = this.selectableMolecules.findIndex(selectableMolecule => selectableMolecule.molecule.inchi===selectedMolecule.inchi)
            if(index!=-1) {
                var updatedMolecule = this.selectableMolecules.find(selectableMolecule => selectableMolecule.molecule.inchi===selectedMolecule.inchi);
                updatedMolecule.selected = !updatedMolecule.selected;
                this.$emit('get-molecules', this.filterSelectedMolecules(this.selectableMolecules))
            }
        },
        filterSelectedMolecules(selectableMolecules) {
            return selectableMolecules.filter(selectableMolecule => selectableMolecule.selected).map(selectableMolecule => selectableMolecule.molecule);
        }
    },
    watch: {
        selectedMolecules(newValue) {
            this.selectableMolecules = this.initSelectableMolecules(newValue);
        }
    }
}
</script>